// extracted by mini-css-extract-plugin
module.exports = {"Host":"TaskBorder_Host_1qXhf","Content":"TaskBorder_Content_1FMNh"};